// extracted by mini-css-extract-plugin
export default {"head":"Contracts_head__-LZT5","body":"Contracts_body__C-kkt","row":"Contracts_row__vrqNr","cell":"Contracts_cell__+1SZ2"};